import { useQuery, UseQueryOptions } from 'react-query';

import { DataRoomDownload, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDocumentDownloadHistoryQuery(
	guid: Guid | undefined,
	documentGuid: Guid | undefined,
	options?: Omit<UseQueryOptions<DataRoomDownload[], unknown, DataRoomDownload[]>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Documents.History(guid, documentGuid),
		() =>
			AxiosUtils.getResponseData<DataRoomDownload[]>(
				api.get(CerebroApiEndpoints.Documents.History(guid, documentGuid))
			),
		options
	);
}
